import "./SelectPage.scss"
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {useLocation, useNavigate} from "react-router-dom";
import {useCookies} from "react-cookie";
import Logo from "../../Atoms/Logos/Logo";
import styled from "styled-components";
import GreenBtnB from "../../Atoms/Buttons/RedBtnB";
import WhiteBtnB from "../../Atoms/Buttons/WhiteBtnB";
import PoorRtan from "../../Atoms/Rtans/PoorRtan";
import GiftCard from "../../Atoms/Cards/GiftCard";
import YellowBtnRS from "../../Atoms/Buttons/YellowBtnRS";
import Modal from "../../Atoms/Modals/Modal";
import {useEffect, useState} from "react";
import modalImg from "./giftmodal.png"
import {sendCPLog} from "../../../Utils/Log/CPlog"
import BlackBtnB from "../../Atoms/Buttons/BlackBtnB";
import {config} from "../../../config";

const ResultWrapper = styled.div`
padding-bottom: 49.5px;
background-color: #edefea;
display: flex;
flex-direction: column;
align-items:center;
justify-content: center;

h3 {
margin-top: 49.5px;
  flex-grow: 0;
  object-fit: contain;
  font-family: "Cafe24Ohsquare";
  font-size: 26px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000;
}
`

const Header = styled.div`
background-color: white;
padding: 16px 0 1px;
    h3 {
  height: 27px;
  flex-grow: 0;
  font-family: "Pretendard";
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: 0.05px;
  text-align: center;
  color: #000;
b {
vertical-align: text-bottom;
width: 67px;
  height: 22px;
  flex-grow: 0;
  font-family: "Cafe24Ohsquare";
  font-size: 19px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000;
}
}
`

const BtnContainer = styled.div`
display: flex;
flex-direction: column;
align-item: center;
gap: 16px;
margin-top: 44px;
`

const GiftWrapper = styled.div`
padding: 44px 0;
width: 100%;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  object-fit: contain;
  border-radius: 8px;
  background-color: #fff;
  
  h3 {
  margin: 0;
  flex-grow: 0;
  font-family: "GmarketSans";
  font-size: 24px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: 0.06px;
  text-align: center;
  color: #000;
  font-weight: 500;
  b {font-weight: bold;}
  }
  
  p {
  margin: 0;
  flex-grow: 0;
  font-family: "GmarketSans";
  font-size: 21px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: 0.05px;
  text-align: center;
  color: #000;
  }
`

export default () => {
    const {state} = useLocation();
    const logObj = state?.logObj;
    const navigate = useNavigate();
    const [cookie, setCookie, removeCookie] = useCookies([]);
    const [modalVisible, setModalVisible] = useState(0);
    const [modalVisible2, setModalVisible2] = useState(0);
    const user = cookie.userinfo;

    useEffect(() => {
        if (typeof logObj === 'undefined' || Object.keys(logObj).length === 0) {
            navigate("/nb/selection")
        }

        sendCPLog("nb_quiz_response", logObj);
    },[])

    const login = () => {
        const nextUrl = `${config.online.url}/mypage/mycoupon?coupon_code=spcsdc&from=quiz`;
        window.location.href = `${config.online.url}/login?next=${encodeURIComponent(nextUrl)}`;
    }

    const toggleModal = () => setModalVisible([1, 0][modalVisible]);
    const toggleModal2 = () => setModalVisible2([1, 0][modalVisible2]);

    return (
        <div className={"selection-wrapper"}>
            <Header>
                <Logo/>
                <h3>
                    <b>국카찬스</b>
                    &nbsp;조회결과
                </h3>
            </Header>
            <ResultWrapper shown={user}>
                <h3>앗, 나는 받을 돈이 없네...</h3>
                <PoorRtan/>
            </ResultWrapper>
            <GiftWrapper>
                <p>
                    국카찬스가 안된다면,
                </p>
                <h3 style={{marginBottom: "24px"}}><b>스파르타 찬스</b>가 있습니다!</h3>
                <div style={{cursor: "pointer"}} onClick={()=> {
                    toggleModal();
                    sendCPLog("nb_quiz_click_button", {"button_text": "스파르타 찬스 확인", "is_image": true});
                }}>
                    <GiftCard/>
                </div>
                <YellowBtnRS style={{marginTop: "12px"}} onClick={()=> {
                    toggleModal();
                    sendCPLog("nb_quiz_click_button", {"button_text": "스파르타 찬스 확인"});
                }}>
                    스파르타 찬스 확인
                </YellowBtnRS>
                <BtnContainer className="btn-container">
                    <CopyToClipboard text={"https://nbquiz.spartacodingclub.kr/nb"} onCopy={toggleModal2}>
                        <BlackBtnB>
                            친구에게 알려주기
                        </BlackBtnB>
                    </CopyToClipboard>
                    <WhiteBtnB onClick={() => navigate("/nb/selection")}>
                        퀴즈 다시 해보기
                    </WhiteBtnB>
                </BtnContainer>
            </GiftWrapper>
            <Modal toggle={toggleModal} open={modalVisible}>
                <GiftModal onClick={login}>
                    <img src={modalImg} alt="선물 패키지"/>
                </GiftModal>
            </Modal>
            <Modal toggle={toggleModal2} open={modalVisible2}>
                <ResultModal>
                    링크가 복사되었습니다! <br/>
                    지금 바로, 친구에게 알려줍시다!
                </ResultModal>
            </Modal>
        </div>
    )
}

const GiftModal = styled.div`
cursor: pointer;
position: relative;
width: 312px;
  height: 416px;
  margin: 0;
  object-fit: contain;
  border-radius: 12px;
  background-image: linear-gradient(to bottom, #fff 0%, #fff8d2);
  img {
  width: 100%;
  }
    `

const ResultModal = styled.div`
    height: 100px;
    width: 320px;
    background-color: white;
    
    display: flex;
    align-items: center;
    justify-content: center;
    
    border-radius: 8px;
    
    flex-grow: 0;
  font-family: "Pretendard";
  font-size: 15px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: 0.04px;
  text-align: center;
  color: #000;
  `